"use client";

import { FC } from "react";
import Link from "next/link";
import { useParams } from "next/navigation";
import classNames from "classnames";

import { Navbar } from "components/molecules/Navbar/Navbar";
import { NavbarSecondary } from "components/molecules/Navbar/NavbarSecondary";
import { Container } from "components/organisms/Container/Container";

import { IDatoGeneralMeta } from "@types";

import { useUtmParams } from "utils/hooks/useUtmParams";

import s from "./Header.module.scss";
import { getPublicLocale, Locale } from "consts/locale";
import { Image } from "react-datocms";

interface Props {
  logo: IDatoGeneralMeta["logo"];
  secondaryNavbarItems: IDatoGeneralMeta["secondaryNavigation"];
  mainNavbarItems: IDatoGeneralMeta["mainNavigation"];
  navCta: IDatoGeneralMeta["navCta"];
}

export const Header: FC<Props> = ({ logo, secondaryNavbarItems, mainNavbarItems, navCta }) => {
  const params = useParams();
  const locale = params?.locale as Locale;
  const publicLocale = getPublicLocale(locale);

  // Make sure utm params are persisted
  useUtmParams();

  return (
    <>
      <NavbarSecondary items={secondaryNavbarItems} />
      <header
        className={classNames(s.Header, {
          [s.IsOpen]: false,
        })}
      >
        <Container size="l">
          <div className={s.Inner}>
            <a href="#content" className={s.SkipContent}>
              Skip to content
            </a>
            <Link href={`/${publicLocale}`} aria-label="Pia Group" className={s.Logo}>
              <Image data={logo.responsiveImage} priority />
            </Link>
            <Navbar mainNavbarItems={mainNavbarItems} navCta={navCta} />
          </div>
        </Container>
      </header>
    </>
  );
};
